import { Component, ElementRef, ViewChild, AfterViewInit, OnDestroy, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { VehicleType } from '../typescript/vehicleType';
import { ArrivalService } from '../admin/_services/arrival/arrival.service';
import { GetWorkStationDisplayResponse } from '../typescript/getWorkStationDisplayResponse';
import { WorkReservationDisplayModel } from '../typescript/workReservationDisplayModel';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { WorkStationDisplayModel } from '../typescript/workStationDisplayModel';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';
import { Globals } from '../admin/globals.service';
declare const QRCode: any;
@Component({
  standalone: true,
  selector: 'app-selfcare',
  templateUrl: './selfcare.component.html',
  styleUrls: ['./selfcare.component.scss'],
  animations: [
    trigger('OpaIn', [
      state('in', style({ opacity: '1' })),
      transition('void => *', [style({ opacity: '0' }), animate(140)]),
      transition('* => void', [animate(140, style({ opacity: '0' }))]),
    ]),
  ],
  imports: [TranslateModule, DatePipe],
})
export class SelfcareComponent implements AfterViewInit, OnDestroy {
  route = inject(ActivatedRoute);
  arrivalService = inject(ArrivalService);
  private translate = inject(TranslateService);
  private globals = inject(Globals);

  @ViewChild('QRTag', { static: false }) QRTag: ElementRef;
  @ViewChild('QRTag2', { static: false }) QRTag2: ElementRef;
  mVehicleType = VehicleType;
  selectedReservation: WorkReservationDisplayModel = null;
  displayCode = '';
  showSelfCareText = false;
  t: ReturnType<typeof setInterval>;
  selfcareText: string;
  wasReservation = false;
  public reservations: WorkReservationDisplayModel[] = [];
  iconUrl = '';

  workStations: WorkStationDisplayModel[] = [];

  constructor() {
    this.translate.setDefaultLang(this.globals.getLang().split('-')[0]);
    this.displayCode = this.route.snapshot.params.ids;
    this.getAndSetWorkReservations().then(() => {
      this.t = setInterval(() => {
        this.getAndSetWorkReservations();
      }, 30000);
    });
  }

  ngAfterViewInit() {
    this.fillQRCodeDiv();
  }

  fillQRCodeDiv() {
    new QRCode(document.getElementById('QRTag'), {
      text: 'https://itunes.apple.com/us/app/mypoint-s/id1455197785?mt=8&ign-mpt=uo%3D2',
      width: 100,
      height: 100,
      colorDark: '#F7A600',
      colorLight: '#ffffff',
      correctLevel: QRCode.CorrectLevel.H,
    });
    new QRCode(document.getElementById('QRTag2'), {
      text: 'https://play.google.com/store/apps/details?id=hu.codevision.points',
      width: 100,
      height: 100,
      colorDark: '#F7A600',
      colorLight: '#ffffff',
      correctLevel: QRCode.CorrectLevel.H,
    });
  }

  async getAndSetWorkReservations() {
    return new Promise<void>((resolve, reject) => {
      this.arrivalService.getSelfCare(this.displayCode).subscribe({
        next: (ok: GetWorkStationDisplayResponse) => {
          this.workStations = ok.workStations;
          this.reservations = ok.workReservations;
          this.selfcareText = ok.selfCareText.trim();
          if (this.iconUrl === '') {
            this.iconUrl = ok.iconUrl;
          }

          if (this.wasReservation && (this.reservations === null || this.reservations.length === 0)) {
            this.fillQRCodeDiv();
          }
          this.wasReservation = this.reservations !== null && this.reservations.length > 0;
          resolve();
        },
        error: (error) => {
          reject(error);
        },
      });
    });
  }

  getVehicleName(num) {
    return this.mVehicleType[num];
  }

  acceptReservation() {
    this.arrivalService.putSelfcareArrival(this.selectedReservation.referenceId).subscribe(() => {
      this.selectedReservation = null;
      if (this.selfcareText.length > 0) {
        this.showSelfCareText = true;
      }
      this.getAndSetWorkReservations();
    });
  }

  ngOnDestroy(): void {
    clearInterval(this.t);
  }

  GetStation(selectedReservation: WorkReservationDisplayModel): string {
    const workStation = this.workStations.find((ws) => ws.id === selectedReservation.workStationId);
    return workStation ? workStation.name : '';
  }
}
